import type { FC } from "react";

import styled from "styled-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import MmxBetaBanner from "../components/MmxBetaBanner/MmxBetaBanner";

import { BetaChannelsOverviewBarChartContainer } from "./components/BetaChannelsOverviewBarChartContainer/BetaChannelsOverviewBarChartContainer";
import BetaChannelTrafficChartContainer from "./components/BetaChannelTrafficChartContainer/BetaChannelTrafficChartContainer";
import BetaTrafficSourcesTable from "./components/BetaTrafficSourcesTable/BetaTrafficSourcesTable";

const Container = styled(FlexColumn)`
    gap: 24px;
`;
export const MmxBetaContainer: FC = () => {
    const addToDashboardButtonProps = { isDisabled: true, tooltipContent: "mmx.beta.dashboard.not.available" };
    return (
        <Container>
            <MmxBetaBanner isBetaMode={true} />
            <BetaChannelsOverviewBarChartContainer addToDashboardButtonProps={addToDashboardButtonProps} />
            <BetaChannelTrafficChartContainer addToDashboardButtonProps={addToDashboardButtonProps} />
            <BetaTrafficSourcesTable />
        </Container>
    );
};
